export default __webpack_public_path__ + "static/media/Background_00232.533724bd.png";